import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';


import './styles.scss';

const Picture = ({
  src,
  alt,
  className,
  has2x,
  has3x,
  hasWebp,
  onLoaded,
  width,
  height,
  loading
}) => {
  // Build srcSet
  const imageRef = useRef();
  const [loaded, setLoaded] = useState();
  let srcSet = `${src} 1x`;
  const i = src.lastIndexOf('.');
  const j = src.lastIndexOf('?');
  const filename = i < 1 ? src : src.slice(0, i);
  const ext = i < 1 ? '' : src.slice(i + 1, src.length + 1);
  const params = j < 1 ? '' : src.slice(j, src.length + 1);
  if (has2x) {
    srcSet += `, ${filename}@2x.${ext} 2x`;
  }
  if (has3x) {
    srcSet += `, ${filename}@3x.${ext} 3x`;
  }
  //Build sources
  let sources = [];
  if (hasWebp) {
    let url = `${filename}.webp${params} 1x`;
    if (has2x) {
      url += `, ${filename}@2x.webp${params} 2x`;
    }
    if (has3x) {
      url += `, ${filename}@3x.webp${params} 3x`;
    }
    sources.push({ url, type: 'image/webp' });
  }


  useEffect(() => {
    //This is needed because onLoad is not getting called when image is loaded from cache
    if (imageRef.current && imageRef.current.complete) {
      onImageLoad();
    }
  }, []);

  const onImageLoad = () => {
    if (!loaded) {
      // setTimeout(() => {
      //   setLoaded(true);
      // }, 1000);
      setLoaded(true);
      onLoaded && onLoaded();
    }
  }

  return (
    <picture>
      {sources.map((source, i) => (
        <source srcSet={source.url} type={source.type} key={`image_${source}_${i}`}/>
      ))}
      <img ref={imageRef} src={src} srcSet={srcSet} alt={alt} className={className} onLoad={onImageLoad} onError={onImageLoad} width={width} height={height} loading={loading}/>
    </picture>
  );
}


Picture.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  has2x: PropTypes.bool,
  has3x: PropTypes.bool,
  hasWebp: PropTypes.bool,
  onLoaded: PropTypes.func,
  width: PropTypes.number,
  height: PropTypes.number,
  loading: PropTypes.string
};


Picture.defaultProps = {
  alt: '',
  className: '',
  has2x: false,
  has3x: false,
  hasWebp: false,
  onLoaded: undefined,
  width: undefined,
  height: undefined,
  loading: 'eager'
};

export default Picture;
